<template>
  <div class="fr-container fr-mb-4w datagouv-components">
    <slot />
  </div>
</template>
